import {ProtectPlusAction, State} from './types'
import {createContext, Dispatch, ReactNode, useContext} from 'react'
import {useProtectPlusReducer} from './reducer'

interface ProviderData {
	dispatch: Dispatch<ProtectPlusAction>
	state: State
}

const Context = createContext<ProviderData>({} as ProviderData)

export const ProtectPlusProvider = ({children}: {children: ReactNode}) => {
	const [state, dispatch] = useProtectPlusReducer()
	return (
		<Context.Provider value={{dispatch, state}}>
			{children}
		</Context.Provider>
	)
}

export const useProtectPlusContext = () => useContext(Context)
